import React from "react";
import { useState } from "react";
import { NavLink, Link } from "react-router-dom";

import "./AttractionsCard.css";

export const AttractionsCard = (props) => {
  const attraction = props.props;

  return (
    <div className="attractions-card">
      <h3>{attraction.title}</h3>
      <p>{attraction.description}</p>
      <div className="attractions-media-grid">
        <div className="attractions-grid-item">
          <div>
            <img className="attractions-img" src={attraction.img} />
          </div>
        </div>
        <div className="attractions-grid-item">
          <iframe
            src={attraction.map}
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};
